module.exports = __webpack_public_path__ + "img/telemarketer.2a158d37.png";